import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import * as cloud from "./store";
import * as settings from "../settings/store";
import { warn } from "../infra/effects";

export const createCloudApi = (
  db: MarlinStoreDb,
  { files, updater }: Pick<HostCapabilities, "files" | "updater">,
) => ({
  getSyncedAt: () => cloud.getSyncedAt(db),
  exportConfiguration: () => cloud.exportConfiguration(db),
  markSynced: (syncedAt: string) => cloud.markSynced(db, syncedAt),
  importConfiguration: async (config: cloud.CloudConfiguration) => {
    const result = await cloud.importConfiguration(db, config);
    const content = await settings.getIpJsonContent(db);
    if (content) await files?.writeIpJson(content).catch(warn("ip.json write"));
    await updater
      ?.applyDatarouterConfig(await settings.getDatarouterConfig(db))
      .catch(warn("datarouter apply"));
    return result;
  },
});

export type CloudApi = ReturnType<typeof createCloudApi>;
